<template>
    <transition>
        <div class="new_main" v-cloak>
            <div class="title">
                <span @click="goHome">首页</span> > 企业资讯
            </div>
            <ul class="new_ul">
                <li
                    class="new_list_item"
                    v-for="(item, index) in newsList"
                    :key="index"
                >
                    <router-link :to="'/newsDetail/' + item.id">
                        <i></i>
                        <div class="new_title">
                            <span v-if="item.type">{{ item.type }}</span>{{ item.title }}
                        </div>
                        <div class="new_date">
                            {{ item.release_time | formatDate }}
                        </div>
                        <div class="new_detail">
                            {{ item.desc }}
                        </div>
                        <div class="clear"></div>
                    </router-link>
                </li>
            </ul>
            <div class="new_page" v-if="newsList.length > 0">
                <el-pagination
                    v-cloak
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    :total="total"
                    @current-change="handleCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
    </transition>
</template>
<script>
import { formatDate } from "@/assets/js/date.js";
export default {
    data() {
        return {
            newsList: [],
            currentPage: 1,
            pageSize: 6,
            total: 0,
        };
    },
    filters: {
        formatDate: function (time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd");
        },
    },
    mounted() {
        this.getNewsList(1);
    },
    beforeDestroy() {},
    methods: {
        goHome: function () {
            this.$router.push({ path: "/" });
        },
        getNewsList: function (page) {
            let datas = {
                page: page,
                page_size: this.pageSize,
            };
            this.getHttp(this, datas, "/front/news/list", function (obj, data) {
                let data_ = data.data;
                obj.newsList = data_.data_list;
                obj.total = data_.total;
            });
        },
        handleCurrentChange: function (val) {
            // console.log(`当前的是第几页:${val}`);
            this.getNewsList(val);
            this.$nextTick(() => {
                // 点击分页后回到顶部
                // this.scrollWindow()
                window.scrollTo(0, 500);
            });
        },
    },
};
</script>
<style scope lang="scss">
.el-pagination.is-background .el-pager li:not(.disabled).active {
    border: 0;
    background-image: linear-gradient(#3099f3, #3b5de6);
}
.el-pager li.active + li {
    border-left: 1px solid #3096f2;
}
.el-pager li,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
    font-weight: 500;
    color: #fff !important;
    border: 1px solid #3096f2;
    background-color: inherit !important;
}
.new_main {
    width: 100%;
    min-height: 9rem;
    background: url("../assets/pcImg/new/bg.jpg") no-repeat;
    background-size: 100% 100%;
    position: relative;
    .title {
        width: 12rem;
        height: 1rem;
        line-height: 1rem;
        padding-left: 0.5rem;
        position: absolute;
        top: 1.3rem;
        left: 50%;
        z-index: 1;
        margin-left: -6rem;
        color: white;
        font-size: 0.16rem;
        border-bottom: 2px solid #383c44;
        cursor: default;
        span {
            cursor: pointer;
        }
    }
    .new_ul {
        width: 12rem;
        position: relative;
        left: 50%;
        margin-left: -6rem;
        padding-top: 2.4rem;
        z-index: 0;
        list-style: none;
        li {
            width: 100%;
            border-bottom: 1px solid #383c44;
            padding: 0.4rem;
            position: relative;
            cursor: pointer;
            z-index: 0;
            .new_title {
                color: white;
                font-size: 0.22rem;
                width: 80%;
                float: left;
                height: 0.6rem;
                line-height: 0.6rem;
                text-align: left;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                span {
                    display: inline-block;
                    margin-right: .1rem;
                    margin-bottom: .055rem;
                    padding: .01rem .07rem;
                    line-height: initial;
                    font-size: 0.18rem;
                    color: #00ffff;
                    border: 1px solid #00ffff;
                    vertical-align: middle;
                    box-sizing: border-box;
                }
            }
            .new_date {
                color: #b3b2b1;
                font-size: 0.18rem;
                width: 20%;
                float: left;
                height: 0.6rem;
                line-height: 0.6rem;
                text-align: right;
            }
            .new_detail {
                color: #b3b2b1;
                font-size: 0.16rem;
                width: 80%;
                float: left;
                height: 0.4rem;
                line-height: 0.4rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
            }
        }
        li i {
            width: 0;
            height: 1.5px;
            border-radius: 1.5px;
            content: "";
            background-color: #f08200;
            position: absolute;
            left: 50%;
            right: 50%;
            bottom: -3px;
            transition: all 0.7s;
            z-index: -1;
        }
        li:hover i {
            width: 100%;
            right: 0%;
            bottom: 0%;
            left: 0%;
        }
    }
    .new_page {
        width: 12rem;
        position: relative;
        bottom: -0.5rem;
        left: 50%;
        margin-left: -6rem;
        text-align: center;
    }
}
</style>
